if (!customElements.get('product-template-notice')) {
  class ProductTemplateNotice extends HTMLElement {
    constructor() {
      super();
      this.variantData = null;
      this.settings = null;
    }

    connectedCallback() {
      // Lade Varianten-Daten
      const dataScript = this.querySelector('script[data-variant-data]');
      if (dataScript) {
        try {
          this.variantData = JSON.parse(dataScript.textContent);
        } catch (e) {
          console.error('Error parsing variant data:', e);
        }
      }

      // Lade Settings
      const overridesData = this.dataset.overrides;
      if (overridesData) {
        try {
          this.settings = JSON.parse(overridesData);
        } catch (e) {
          console.error('Error parsing settings:', e);
        }
      }

      // Höre auf Varianten-Änderungen
      window.addEventListener('variant:update', this.handleVariantChange.bind(this));
      
      // Initiales Laden - zeige Hinweis für die erste/aktuelle Variante
      const initialVariantInput = document.querySelector('input[name="id"]:checked') || 
                                   document.querySelector('input[name="id"]') ||
                                   document.querySelector('select[name="id"]');
      if (initialVariantInput && initialVariantInput.value) {
        this.updateNotice(initialVariantInput.value);
      }
    }

    handleVariantChange(event) {
      
      if (!event.detail || !event.detail.resource) return;
      
      const variantId = event.detail.resource.id.toString();
      
      this.updateNotice(variantId);
    }

    updateNotice(variantId) {
      
      if (!this.variantData || !this.variantData[variantId]) {
        this.hideNotice();
        return;
      }

      const variantInfo = this.variantData[variantId];
      
      if (!variantInfo.type) {
        this.hideNotice();
        return;
      }

      // Prüfe Override
      let noticeText = '';
      const overrideKey = `override_${variantInfo.type.toLowerCase().replace(/\s+/g, '_')}`;
      const textKey = `${variantInfo.type.toLowerCase().replace(/\s+/g, '_')}_text`;
      
      if (this.settings && this.settings[overrideKey] && this.settings[textKey]) {
        noticeText = this.settings[textKey];
      } else if (variantInfo.description) {
        // Prüfe ob description ein Objekt mit .value ist oder direkt ein String
        noticeText = typeof variantInfo.description === 'object' && variantInfo.description.value 
          ? variantInfo.description.value 
          : variantInfo.description;
      }

      if (!noticeText) {
        this.hideNotice();
        return;
      }

      // Update Text
      const textContainer = this.querySelector('.template-notice__text');
      if (textContainer) {
        textContainer.innerHTML = noticeText;
        
        // Füge Link hinzu
        const showLink = this.dataset.showLink === 'true';
        if (showLink && variantInfo.linkText && variantInfo.linkUrl) {
          textContainer.innerHTML += `<br><a href="${variantInfo.linkUrl}" class="template-notice__link">${variantInfo.linkText}</a>`;
        }
      }

      // Zeige Notice
      const noticeElement = this.querySelector('[data-template-notice]');
      if (noticeElement) {
        noticeElement.style.display = 'block';
        noticeElement.setAttribute('data-template-type', variantInfo.type.toLowerCase().replace(/\s+/g, '-'));
      }
    }

    hideNotice() {
      const noticeElement = this.querySelector('[data-template-notice]');
      if (noticeElement) {
        noticeElement.style.display = 'none';
      }
    }
  }

  customElements.define('product-template-notice', ProductTemplateNotice);
}
